import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout, message } from 'antd';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropertyList from '~pages/pms-dashboard/properties';
import PendingApprovalList from '~pages/pms-dashboard/properties/listing-management/pending-approval/list';
import PropertyListingManagement from '~pages/pms-dashboard/properties/listing-management';
import PropertyCommission from '~pages/pms-dashboard/properties/commission';
import PropertyDepositAndFees from '~pages/pms-dashboard/properties/deposit-and-fees';
import PropertyCreate from '~pages/pms-dashboard/properties/create';
import PropertyRecord from '~pages/pms-dashboard/properties/record';
import PropertyTerms from '~pages/pms-dashboard/properties/terms';
import Constructing from '~pages/pms-dashboard/constructing';
import { getUserAuth, setSelectRole } from '~actions/pms-actions/auth';
import { fireCustomEvent } from '~helpers/custom-events';
import generatePath from '~settings/routing';
import PropertyHomepage from '~pages/pms-dashboard/properties/homepage';
import Account from '~pages/pms-dashboard/account';
import LoginAndScurity from '~pages/pms-dashboard/account/login-security';
import queryString from 'query-string';
import ListingPlan from './account/listing-plan';
import { formatAuthPayload } from '~helpers/auth';

const mapStateToProps = state => ({
  token: state.auth.getIn(['base', 'token']),
  currentRoleSlug: state.pmsReducer.auth.get('auth').currentRoleSlug,
});

const mapDispatchToProps = dispatch => ({
  getUserAuth: onSuccess => {
    dispatch(getUserAuth(onSuccess));
  },
  setSelectRole: payload => {
    dispatch(setSelectRole(payload));
  },
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
export default class PmsDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
      nowTab: this.props.location.pathname,
      showSwitchRolePage: true,
      showSwitchRoleModal: false,
      automaticCloseMenu: true,
      showPendingApprove: false,
    };

    this.customSidebar = false;
  }

  componentDidMount() {
    // Open liveChat modal if query string matched.
    const search = queryString.parse(window.location.search);
    if (search.landlord_open_msg_center === 'true') {
      setTimeout(() => {
        fireCustomEvent('msgCenterModalOpen');
      }, 1000);
    }

    this.handleUserAuth(this.props);
    message.config({
      maxCount: 1,
    });
    window.addEventListener('resize', this.packUpMenu);
    window.addEventListener('triggerSwitchRole', this.handleSwitchRole);
    window.addEventListener('triggerCloseMenu', this.closeMenu);
    this.packUpMenu();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.packUpMenu);
    window.removeEventListener('triggerSwitchRole', this.handleSwitchRole);
    window.removeEventListener('triggerCloseMenu', this.closeMenu);
  }

  handleCloseSwitchRolePage = () => {
    this.setState({
      showSwitchRolePage: false,
    });
  };

  handleCloseSwitchRoleModal = () => {
    this.setState({
      showSwitchRoleModal: false,
    });
  };

  handleSwitchRole = () => {
    this.props.getUserAuth(() => {
      this.setState({
        showSwitchRoleModal: true,
      });
    });
  };

  handleUserAuth = props => {
    props.getUserAuth(auth => {
      props.setSelectRole(formatAuthPayload(auth, 'landlord'));
    });
  };

  packUpMenu = () => {
    const windowWidth = document.body.clientWidth;
    const pendingApprove = document.querySelector('.dashboard__pending-approval');
    const pendingApproveWidth = pendingApprove ? pendingApprove.clientWidth : 0;

    if (windowWidth - pendingApproveWidth <= 924 && !this.state.collapsed && !this.customSidebar) {
      this.setState({ collapsed: true });
    }

    if (windowWidth - pendingApproveWidth > 924 && this.state.collapsed && !this.customSidebar) {
      this.setState({ collapsed: false });
    }
  };

  handlePendingApprove = value => {
    if (this.state.showPendingApprove !== value) {
      this.setState({ showPendingApprove: value });
    }
  };

  closeMenu = () => {
    if (this.state.automaticCloseMenu) {
      this.setState({
        collapsed: true,
        automaticCloseMenu: false,
      });
    }
  };

  toggleCollapseSidebar = () => {
    this.customSidebar = true;
    this.setState({
      collapsed: !this.state.collapsed,
    });

    setTimeout(() => {
      fireCustomEvent('toggleCollapseSidebarTriggers');
    }, 200);
  };

  isNoContentMarginPage = () => {
    const { pathname } = this.props.location;
    if (
      pathname.includes('/homepage') ||
      pathname.includes('/commission') ||
      pathname.includes('/deposit-and-fees') ||
      (pathname.includes('/property/') && !pathname.includes('/create'))
    ) {
      return true;
    }

    return false;
  };

  render() {
    if (!this.props.token || this.props.token.length === 0) {
      return (
        <Redirect
          to={generatePath(
            'login',
            {},
            {
              redirectUrl: this.props.location.pathname,
            },
          )}
        />
      );
    }

    const { Content } = Layout;

    return (
      <Layout className="dashboard">
        <Layout className="dashboard__layout">
          <Content
            className={classNames('dashboard__content', {
              'dashboard__content--properties': this.props.location.pathname === '/properties',
              'dashboard__content--no-margin': this.isNoContentMarginPage(),
            })}
          >
            <Switch>
              <Route path={'/not-available'} component={Constructing} />
              <Route
                path={'/properties'}
                exact
                render={({ location }) => (
                  <PropertyList
                    handlePendingApprove={this.handlePendingApprove}
                    location={location}
                    hasHerculesProperties={this.props.hasHerculesProperties}
                  />
                )}
              />
              <Route
                path={'/property/:propertySlug/edit'}
                exact
                component={PropertyListingManagement}
              />
              <Route path={'/property/:propertySlug/homepage'} exact component={PropertyHomepage} />
              <Route
                path={'/property/:propertySlug/commission'}
                exact
                component={PropertyCommission}
              />
              <Route path={'/property/:propertySlug/record'} exact component={PropertyRecord} />
              <Route
                path={'/property/:propertySlug/deposit-and-fees'}
                exact
                component={PropertyDepositAndFees}
              />
              <Route
                path={'/property/create'}
                exact
                render={props => (
                  <PropertyCreate
                    {...props}
                    companyID={this.props.companyID}
                    companyName={this.props.companyName}
                  />
                )}
              />
              <Route path={'/account'} exact component={Account} />
              <Route path={'/account/listing-plan'} exact component={ListingPlan} />
              <Route path={'/account/profile'} exact component={Account} />
              <Route path={'/account/security'} exact component={LoginAndScurity} />
              <Route path={'/property/:propertySlug/terms'} exact component={PropertyTerms} />
            </Switch>
            <If
              condition={
                this.props.location.pathname === '/properties' && this.state.showPendingApprove
              }
            >
              <div className="dashboard__pending-approval">
                <PendingApprovalList
                  t={this.props.t}
                  onPendingApprove={this.handlePendingApprove}
                  history={this.props.history}
                />
              </div>
            </If>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

PmsDashboard.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  token: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  getUserAuth: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  companyID: PropTypes.string,
  companyName: PropTypes.string,
  hasHerculesProperties: PropTypes.bool,
};

PmsDashboard.defaultProps = {
  companyName: '',
  companyID: '',
  location: {
    pathname: '',
  },
  token: '',
  t: () => {},
  getUserAuth: () => {},
  history: {
    push: () => {},
  },
  hasHerculesProperties: false,
};
